<template>
    <div>
        <base-crud
                crudName="Sub-Categorias de Produtos"
                newText="Nova Sub-Categoria"
                :table="subCategoryProductTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="true"
                :enableDelete="false"
                :enableView="false"
                :enableSetStatus="true"
        >
        </base-crud>

    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                subCategoryProductTable: 'subCategoryProductTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'category_product', 'description', 'status', 'photo', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id','category_product','description', 'status'],
                    pagination: {chunk: 10, dropdown:false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    templates: {
                        category_product: function (h, row, index) {
                            return (row.category_product) ? row.category_product.description : row.category_product
                        },
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    },
                    headings: {
                        'category_product': 'Categoria do Produto',
                        'description': 'Sub-Categoria',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    }
                },
                endPoint: 'subCategoryProduct/'
            }
        },
        components: {
            BaseCrud
        }

    }
</script>

<style >

    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/SubCategoryProduct/Crud.vue